import React from 'react';
import { useSelector } from 'react-redux';
import { Route, Switch } from 'react-router'
import getParameterFromURL from './../utils/getParameterFromUrl'

import StepsWrapper from "./steps/stepsWrapper/stepsWrapper"
import StyleGuides from "./styleGuides"

import MenuWrapper from "./blocks/menuWrapper"

import Home from "./pages/home"
import Faq from "./pages/faq"
import Contacts from "./pages/contacts"
import TermsPolicies from "./pages/termsPolicies"
import store from '../store';

import "./app.scss"

window.initHeight = window.visualViewport.height

function setButtonPosition() {
    document.querySelector('html').style.height = window.visualViewport.height + 'px'
    document.documentElement.style.setProperty('--viewportHeight', window.visualViewport.height)
    
    if (document.querySelector('.stepContentWrapper')) {
      document.querySelector('.stepContentWrapper').style.minHeight = window.visualViewport.height - 82 + 'px'
    }
    
    if (document.querySelector('.application')) {
      document.querySelector('.application').style.minHeight = window.visualViewport.height + 'px'
    }

    if (document.querySelector('.stepControlWrapper')) {
      if (window.initHeight > window.visualViewport.height) {
        document.querySelector('.stepControlWrapper').style.top = window.visualViewport.height - 82 + 'px'
      } else {
        document.querySelector('.stepControlWrapper').style.top = window.visualViewport.height - 82 + 'px'
      }
    }
}

setButtonPosition();

setInterval(setButtonPosition, 5)

let isTestPaypal = getParameterFromURL('isTestPaypal') === 'true';

const App = () => {
  let currentIndex = useSelector((state) => state.stepsState.currentIndex);

  if (isTestPaypal) {
    return (
      <div>
        <a href="x-web-search://https://verv.com/pay/">x-web-search://https://verv.com/pay/</a>
        <a href="x-web-search://verv.com/pay/">x-web-search://verv.com/pay/</a>
      </div>
    )
  }

  return (
    <div className="application">
      {currentIndex === 0 && <MenuWrapper />}

      <Switch>
        {/* <Route exact path={'/'} component={Home} /> */}
        <Route exact path={'/faq'} component={Faq} />
        <Route exact path={'/contacts'} component={Contacts} />
        <Route exact path={'/terms-and-policies'} component={TermsPolicies} />
        <Route exact path={'/styleGuides'} component={StyleGuides} />
      </Switch>

      <StepsWrapper />
    </div>
  )
}

export default App;